import React, { SFC } from "react";
import { connect } from "dvajs";
import "./index.less";

/**
 *  用来渲染任务item
 *
 * @export
 * @returns
 */
interface IProps {
  item: any;
  children: any;
  changePersonalTaskDraw: (taskId: string, activeTab?: string) => void;
}
const TaskPopover: SFC<IProps> = ({ item, children, changePersonalTaskDraw }) => {
  function onVisibleChange() {
    changePersonalTaskDraw(item.taskId);
  }
  return <span onClick={onVisibleChange}>{children} </span>;
};
function mapDispatchToProps(dispatch: any) {
  return {
    changePersonalTaskDraw(taskId: string, activeTab?: string) {
      return dispatch({
        type: "work/changePersonalTaskDraw",
        payload: { taskId, drawVisible: true, activeTab, chat: true }
      });
    }
  };
}
export default connect(function () {
  return {};
}, mapDispatchToProps)(TaskPopover);
